<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  name: "detail-praktikum",
  props: ["idPraktikum", "idPembelajaran"],
  data() {
    return {
      aPraktikum_data: [],
      aPraktikum_trash: [],
      aPraktikum_ref: [],
      status_ref: ["Tersedia", "Tidak Tersedia"],
      jenOptions: ["Sarana", "Alat Tulis"],
      isAddMaster: false,
      aPraktikum_kode: "",
      aPraktikum_nama: "",
      aPraktikum_jenis: "",
      aPraktikum_deskripsi: "",
      loadingTable: true,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let self = this;
      let conf = {
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/alat-praktikum",
        method: "get",
        params: { idPraktikum: this.idPraktikum },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(conf)
        .then((res) => {
          let resFix = res.data.data[0];
          if (resFix) {
            console.log(resFix);
            resFix.forEach((elm) => {
              let temp = {
                aPraktikum_data: elm,
                isNewRow: false,
                status: elm.status_praktikum_alat,
              };
              self.aPraktikum_data.push(temp);
            });
          }
          self.loadingTable = false;
        })
        .catch((err) => {
          self.loadingTable = false;
          console.log(err);
        });
    },
    addRowAPraktikum() {
      let self = this;
      self.aPraktikum_data.push({
        aPraktikum_data: "",
        isNewRow: true,
        status: null,
      });
    },
    deleteRow(index, row_data) {
      let self = this;
      this.aPraktikum_trash.push(row_data);
      var idx = self.aPraktikum_data.indexOf(row_data);
      if (idx > -1) {
        self.aPraktikum_data.splice(idx, 1);
      }
    },
    onSearchAPraktikum(search, loading) {
      if (search.length) {
        loading(true);
        this.searchAPraktikum(loading, search, this);
      }
    },
    searchAPraktikum: function (loading, search) {
      let self = this;
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/search-alat-lab",
        params: {
          search: search,
          pembelajaranId: self.idPembelajaran,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config).then((response) => {
        if (response.data.meta.code == 200) {
          self.aPraktikum_ref = response.data.data.referensi;
          loading(false);
        } else {
          self.aPraktikum_ref = [
            {
              a_id: 0,
              akomodasi: "-",
            },
          ];
          loading(false);
        }
      });
    },
    storeDataMaster() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/alat-laboratorium",
        data: {
          aLaboratorium_kode: self.aPraktikum_kode,
          aLaboratorium_nama: self.aPraktikum_nama,
          aLaboratorium_jenis: self.aPraktikum_jenis,
          aLaboratorium_deskripsi: self.aPraktikum_deskripsi,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data berhasil di simpan.",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              self.resetInputAkomodasiMaster();
              self.isAddMaster = false;
              Swal.close();
            }
          });
        })
        .catch(function (error) {
          Swal.close();
          self.axiosCatchError = error.response.data.data;
        });
    },
    storeData() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const conf = {
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/alat-praktikum",
        method: "post",
        data: {
          aPraktikums: JSON.stringify(this.aPraktikum_data),
          aPraktikumDelete: JSON.stringify(this.aPraktikum_trash),
          idPembelajaran: this.idPembelajaran,
          idPraktikum: this.idPraktikum,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(conf).then((res) => {
        console.log(res);
        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Data berhasil di simpan.",
          timer: 2000,
          timerProgressBar: true,
          showCancelButton: false,
          showConfirmButton: false,
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            Swal.close();
            self.$emit("refresh-table");
          }
        });
      });
    },
    resetInputAkomodasiMaster() {
      this.aPraktikum_kode = null;
      this.aPraktikum_nama = null;
      this.aPraktikum_jenis = null;
      this.aPraktikum_deskripsi = null;
    },
  },
};
</script>
<style>
th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <b-form class="p-2" @submit.prevent="storeDataMaster">
    <div class="row mb-2">
      <div class="col-12">
        <div class="">
          <button
            v-if="isAddMaster == false"
            type="button"
            @click="isAddMaster = true"
            class="btn btn-sm btn-success"
          >
            <i class="fa fa-plus"></i> Tambah Alat Praktikum Master
          </button>
          <button
            v-else
            type="button"
            @click="isAddMaster = false"
            class="btn btn-sm btn-warning"
          >
            <i class="fa fa-times"></i> Tutup Alat Praktikum Master
          </button>
        </div>
      </div>
    </div>
    <div v-if="isAddMaster == true" class="row">
      <div class="col-lg-12 mt-1">
        <b-form-group label="Kode" label-for="akomodasi_kode">
          <b-form-input
            id="akomodasi_kode"
            placeholder="Masukkan Kode..."
            type="text"
            v-model="aPraktikum_kode"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-lg-12 mt-1">
        <b-form-group label="Nama" label-for="akomodasi_nama">
          <b-form-input
            id="akomodasi_nama"
            placeholder="Masukkan Nama..."
            type="text"
            v-model="aPraktikum_nama"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-lg-12 mt-1">
        <label for="">Jenis</label>
        <v-select
          v-model="aPraktikum_jenis"
          :options="jenOptions"
          label="level"
          placeholder="- Pilih Jenis -"
        >
        </v-select>
      </div>
      <div class="col-lg-12 mt-1">
        <b-form-group label="Deskripsi" label-for="akomodasi_deskripsi">
          <textarea
            class="form-control"
            id="akomodasi_deskripsi"
            cols="30"
            rows="10"
            placeholder="Masukkan Deskripsi"
            v-model="aPraktikum_deskripsi"
          ></textarea>
        </b-form-group>
      </div>
      <!-- end col -->
      <div class="col-lg-6">&nbsp;</div>
      <div class="col-lg-6 mb-4">
        <div class="text-end">
          <b-button type="reset" variant="danger">
            <i class="fa fa-redo-alt"></i> Reset
          </b-button>
          &nbsp;
          <b-button type="submit" variant="primary">
            <i class="fa fa-save"></i> Simpan
          </b-button>
        </div>
      </div>
      <!-- end col -->
    </div>
  </b-form>
  <b-form class="p-2" @submit.prevent="storeData">
    <div v-if="isAddMaster == false" class="">
      <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
        <thead class="bg-dark text-center text-white">
          <tr>
            <th style="width: 25px">No</th>
            <th>Alat</th>
            <th>Jenis</th>
            <th style="width: 250px">Status Ketersediaan</th>
            <th style="width: 50px" class="text-center">
              <b-button
                type="button"
                class="btn btn-success btn-sm"
                v-on:click="addRowAPraktikum"
              >
                <i class="fa fa-plus"></i>
              </b-button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loadingTable == true">
            <td class="text-center" colspan="5">
              <i class="fa fa-spinner fa-spin"></i> Loading...
            </td>
          </tr>
          <tr v-else-if="aPraktikum_data == ''">
            <td class="text-center" colspan="5">Data tidak tersedia</td>
          </tr>
          <tr
            v-else
            v-for="(row_data, key_data) in aPraktikum_data"
            :key="key_data"
          >
            <td class="text-center">{{ key_data + 1 }}.</td>
            <td>
              <v-select
                v-if="row_data.isNewRow"
                label="le_name"
                v-model="row_data.aPraktikum_data"
                :options="aPraktikum_ref"
                @search="onSearchAPraktikum"
                placeholder="Cari dan Pilih Alat Praktikum..."
              >
              </v-select>
              <div v-else>{{ row_data.aPraktikum_data.le_name }}</div>
            </td>
            <td class="text-center">
              {{
                row_data.aPraktikum_data.le_jenis
                  ? row_data.aPraktikum_data.le_jenis
                  : "-"
              }}
            </td>
            <td>
              <v-select v-model="row_data.status" :options="status_ref">
              </v-select>
            </td>
            <td>
              <div class="text-center">
                <div
                  class="btn btn-sm btn-danger"
                  v-on:click="deleteRow(key_data, row_data)"
                >
                  <i class="fa fa-minus"></i>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <div class="row">
        <div class="col-lg-6">&nbsp;</div>
        <div class="col-lg-6 mb-4">
          <div class="text-end">
            <b-button type="submit" variant="success">
              <i class="fa fa-save"></i> Simpan
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>
